var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.6718C0 7.8352 7.16344 0.671753 16 0.671753C24.8366 0.671753 32 7.8352 32 16.6718C32 25.5083 24.8366 32.6718 16 32.6718C7.16344 32.6718 0 25.5083 0 16.6718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6677 11.1714C23.4021 11.3729 23.9804 11.9667 24.1767 12.7207C24.5333 14.0872 24.5333 16.9385 24.5333 16.9385C24.5333 16.9385 24.5333 19.7897 24.1767 21.1564C23.9804 21.9104 23.4021 22.5041 22.6677 22.7057C21.3369 23.0718 16 23.0718 16 23.0718C16 23.0718 10.6631 23.0718 9.33218 22.7057C8.59783 22.5041 8.0195 21.9104 7.82323 21.1564C7.46667 19.7897 7.46667 16.9385 7.46667 16.9385C7.46667 16.9385 7.46667 14.0872 7.82323 12.7207C8.0195 11.9667 8.59783 11.3729 9.33218 11.1714C10.6631 10.8052 16 10.8052 16 10.8052C16 10.8052 21.3369 10.8052 22.6677 11.1714ZM14.4 14.5385V19.8718L18.6667 17.2052L14.4 14.5385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4fb7788c06f21905591a6f764f4d6a95.svg";
export { ForwardRef as ReactComponent };